<script lang="ts" setup>
import LaunchWebApp from './LaunchWebApp.vue'

const { t } = useI18n()
</script>

<template>
  <section>
    <div class="join-revolution">
      <div
        class="text-center text-2xl leading-normal tracking-wide lg:text-[1.75rem] max-w-83"
      >
        {{ t('join-the-revolution-in-event-ticketing') }}
      </div>
      <div
        class="flex flex-row items-center justify-center mt-5.5 gap-5.5 flex-wrap"
      >
        <ReusableInstallButtons />
        <LaunchWebApp />
      </div>
    </div>
  </section>
</template>

<style scoped>
@reference "tailwindcss";
.join-revolution {
  @apply max-w-237.25 mx-auto min-h-61.25 p-5 flex flex-col items-center justify-center rounded-2xl sm:px-0;
  background: url(~/assets/images/mighty-networks-alternative/join-revolution.svg);
  background-size: cover;
  background-position: center;
}
</style>
